import { AppProvider, AppType, AppContextProps } from '@features/contexts/AppProvider';
import { PropsWithChildren } from 'react';
import { clinicalLogStyleKeyByPlatform } from '@features/components/ClinicalData/components/ClinicalLog/constants';
import { CLINICAL_ITEM_TYPE_TO_TEXT } from '@cp/core/constants/clinical-log.constants';
import { etaContent } from '@cp/pages/CaseDetails/components/constants';

const APP_CONFIG: AppContextProps = {
  type: AppType.NopAccessPlatform,
  caseDetails: { etaContent },
  clinicalLog: {
    names: CLINICAL_ITEM_TYPE_TO_TEXT,
    styles: clinicalLogStyleKeyByPlatform[AppType.NopAccessPlatform],
  },
  chartConfig: {
    barChart: { showMaxValueIndicator: false, showBarDiff: false },
  },
  chatConfig: {
    excludedChannelTypesToShare: [],
  },
};

export const CustomerPortalAppProvider = ({ children }: PropsWithChildren) => (
  <AppProvider config={APP_CONFIG}>{children}</AppProvider>
);
